import React, { useState } from 'react';
import { Layout, Breadcrumb } from 'antd';
import { Outlet, useLocation } from 'react-router-dom';
import Header from './Header';
import Sidebar from './Sidebar';

const { Content } = Layout;

const MainLayout: React.FC = () => {
  const [collapsed, setCollapsed] = useState(false);
  const location = useLocation();

  const getBreadcrumbItems = () => {
    const pathSegments = location.pathname.split('/').filter(Boolean);
    
    const breadcrumbNameMap: Record<string, string> = {
      dashboard: 'Дашборд',
      users: 'Пользователи',
      campaigns: 'Кампании',
      settings: 'Настройки',
      create: 'Создать',
      edit: 'Редактировать',
    };

    return pathSegments.map((segment, index) => {
      const url = `/${pathSegments.slice(0, index + 1).join('/')}`;
      const breadcrumbName = breadcrumbNameMap[segment] || segment;
      
      return {
        title: breadcrumbName,
        href: url,
      };
    });
  };

  const breadcrumbItems = getBreadcrumbItems();

  return (
    <Layout style={{ minHeight: '100vh' }}>
      <Sidebar collapsed={collapsed} />
      
      <Layout style={{ marginLeft: collapsed ? 80 : 200, transition: 'margin-left 0.2s' }}>
        <Header 
          collapsed={collapsed} 
          onToggle={() => setCollapsed(!collapsed)} 
        />
        
        <Content style={{ margin: '0 16px' }}>
          {breadcrumbItems.length > 0 && (
            <Breadcrumb
              style={{ margin: '16px 0' }}
              items={breadcrumbItems}
            />
          )}
          
          <div
            style={{
              padding: 24,
              minHeight: 360,
              background: '#fff',
              borderRadius: 8,
            }}
          >
            <Outlet />
          </div>
        </Content>
      </Layout>
    </Layout>
  );
};

export default MainLayout;
